/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const MicroDepositStatus = {
  Verified: "verified",
} as const;
export type MicroDepositStatus = ClosedEnum<typeof MicroDepositStatus>;

/** @internal */
export const MicroDepositStatus$inboundSchema: z.ZodNativeEnum<
  typeof MicroDepositStatus
> = z.nativeEnum(MicroDepositStatus);
/** @internal */
export const MicroDepositStatus$outboundSchema: z.ZodNativeEnum<
  typeof MicroDepositStatus
> = MicroDepositStatus$inboundSchema;
